import { Stack, Typography } from '@mui/material';

export const NoAccessCover = () => {
  return (
    <Stack
      flexGrow={1}
      justifyContent='center'
      alignItems='center'
      height='100%'
      width='100%'
      bgcolor='var(--ucr-palette-card-grey-100)'
      gap='1.5rem'
    >
      <Typography
        variant='h2'
        color='var(--ucr-palette-text-grey-400)'
        textAlign='center'
      >
        Страница не найдена
      </Typography>
      <Typography
        variant='t1'
        color='var(--ucr-palette-text-grey-400)'
        textAlign='center'
        fontWeight='500'
      >
        Проверьте правильность адреса или вернитесь на предыдущую страницу
      </Typography>
    </Stack>
  );
};
